module.exports = __webpack_public_path__ + "static/404.bbea2c44.jpg";